import { gql } from '@apollo/client'

export const PATIENT_QUERY = gql`
  query AP_Patient($id: ID!) {
    patient(id: $id) {
      id
      uuid
      first_name
      last_name
    }
  }
`
